import { logger } from '../logger';
import { BaseNetworkHandler } from './BaseNetworkHandler';

export class FetchError extends Error {
  public status: number;
  public statusText: string;
  constructor(args: { status: number; statusText: string }) {
    super(`Fetch error: ${args.status} - ${args.statusText}`);
    this.status = args.status;
    this.statusText = args.statusText;
  }
}

/** A network handler that uses the fetch API. */
export class FetchNetworkHandler extends BaseNetworkHandler {
  sendRequest(payload: Uint8Array): Promise<void> {
    const { authType, authenticator, protocol, host, path, headers } = this.config;

    return authenticator
      .authRequest(authType, payload, headers)
      .then(
        authedHeaders =>
          new Promise<void>((resolve, reject) => {
            const url = `${protocol}//${host}${path}`;
            return fetch(url, {
              method: 'POST',
              headers: authedHeaders,
              body: payload,
            })
              .then(response => {
                logger.log(
                  'Received response from metrics server. Status code:',
                  response.status,
                  response.statusText
                );
                if (response.ok) {
                  resolve();
                } else {
                  reject(
                    new FetchError({
                      status: response.status,
                      statusText: response.statusText,
                    })
                  );
                }
              })
              .catch((reason: DOMException | TypeError) => {
                reject(
                  new FetchError({
                    status: -1,
                    statusText: reason.message,
                  })
                );
              });
          })
      )
      .catch(e => {
        logger.log('Got error when sending request:', e);
      });
  }
}
